import type { EditableRow } from '../types';

export type RowDiffKind = 'new' | 'modified' | 'unchanged';

export interface RowDiff {
  kind: RowDiffKind;
  /** Field ids that differ from baseline (empty if new or unchanged). */
  modifiedFieldIds: string[];
}

export function diffRowAgainstBaseline(
  row: EditableRow,
  baselineRow: EditableRow | undefined,
  fieldIds: string[]
): RowDiff {
  if (!baselineRow) {
    return { kind: 'new', modifiedFieldIds: [] };
  }
  const modifiedFieldIds = fieldIds.filter(fid => {
    const a = row.fields[fid] ?? '';
    const b = baselineRow.fields[fid] ?? '';
    return a !== b;
  });
  if (modifiedFieldIds.length === 0) {
    return { kind: 'unchanged', modifiedFieldIds: [] };
  }
  return { kind: 'modified', modifiedFieldIds };
}
